import PropTypes from 'prop-types';
import React from 'react';
import { isNextBtnDisabled, showLeftNavButton, showRightNavButton } from '../utilities/navigation';
import ProgressBar from './ProgressBar';

class Navigation extends React.Component {
	constructor(props) {
		super(props);

		this.showLeftNavButton = showLeftNavButton.bind(this);
		this.showRightNavButton = showRightNavButton.bind(this);
		this.isNextBtnDisabled = isNextBtnDisabled.bind(this);
	}

	render() {
		const { resultsSlide, dimensions, progress, goToSlideCallback } = this.props;

		return (
			<div className="ms-form__nav" data-color-scheme="highlight">
				<div className="left">{this.showLeftNavButton()}</div>
				<div className="center">
					<ProgressBar resultsSlide={resultsSlide} dimensions={dimensions} progress={progress} callback={goToSlideCallback} />
				</div>
				<div className="right">{this.showRightNavButton()}</div>
			</div>
		);
	}
}

export default Navigation;

Navigation.propTypes = {
	dimensions: PropTypes.object,
	goToSlideCallback: PropTypes.func,
	progress: PropTypes.oneOfType([PropTypes.bool, PropTypes.object]),
	resultsSlide: PropTypes.number,
};
